import React from 'react';
import SvgIcon from 'e100-react-components/lib/components/SvgIcon';
import { IProps } from 'e100-react-components/lib/components/SvgIcon/index';

export const FilledFilter = (props: IProps) => (
  <SvgIcon {...props}>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M3 8H21V10.9684L15 16.4368V22.5L9 24V16.4368L3 10.9684V8ZM5 10.0316V10H19V10.0316L13 15.5V20.9384L11 21.4384V15.5L5 10.0316Z" />
    <circle cx="22" cy="6" r="5" fill="#50BC46" stroke="white" stroke-width="2"/>
  </SvgIcon>
);
